import React from 'react';
import PropTypes from 'prop-types';

import { TextareaField } from '../../common';

export default function Chats({ values, getHandler, errors, faqs }) {
  const { properties } = faqs;
  return (
    <div className="chats">
      {properties?.what_to_bring && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.what_to_bring?.description ||
                'How would you like TrueLark to respond if a patient asks what they should bring to their appointment?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={values.what_to_bring || ''}
                onChange={getHandler('what_to_bring')}
                error={errors.what_to_bring}
              />
            </div>
          </div>
        </>
      )}
      {properties?.after_appointment_issue && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.after_appointment_issue?.description ||
                'How would you like TrueLark to respond if a patient reports that their crown has fallen off or their fillings are broken after an appointment?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={values.after_appointment_issue || ''}
                onChange={getHandler('after_appointment_issue')}
                error={errors.after_appointment_issue}
              />
            </div>
          </div>
        </>
      )}
      {properties?.after_appointment_care && (
        <>
          <div className="chats__row">
            <p className="chats__row__label">
              {properties?.after_appointment_care?.description ||
                'How would you like TrueLark to respond if a patient reports experiencing pain or bleeding after a procedure?'}
            </p>
          </div>
          <div className="chats__row">
            <div className="chats__row__input chat-textarea">
              <TextareaField
                count
                max={160}
                label=""
                value={values.after_appointment_care || ''}
                onChange={getHandler('after_appointment_care')}
                error={errors.after_appointment_care}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

Chats.defaultProps = {
  getHandler: () => {},
  values: {},
  errors: {},
};

Chats.propTypes = {
  getHandler: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
};
